import type { PermissionResponseDto } from '@evimo/types/api/authorization/permission/permission.response.dto';
import { isPermissionKey } from '@evimo/types/enums/permission-key';
import {
  authorizationRequestInit,
  permissionsApi,
} from '~/app/services/authorization/authorization-api-instances';
import { invokeAuthorizationClient } from '~/app/services/authorization/authorization-api-error';

export type PermissionDto = PermissionResponseDto;

export const PermissionService = {
  async listPermissions(): Promise<PermissionDto[]> {
    const response = await invokeAuthorizationClient(
      'Failed to fetch permissions',
      () =>
        permissionsApi.permissionControllerListPermissions(
          authorizationRequestInit,
        ),
    );

    return response.data.map((permission) => {
      if (!isPermissionKey(permission.key)) {
        throw new Error(`Invalid permission key: ${permission.key}`);
      }

      return {
        id: permission.id,
        key: permission.key,
        description: permission.description,
      } satisfies PermissionDto;
    });
  },
};
